const content = {
  getlist: 'content/getlist',
  add: 'content/add',
  update: 'content/update',
  remove: 'content/remove',
  get: 'content/get',
  getall: 'content/getall',
}
export default content
